import { Link } from "react-router-dom";

// Reusable author byline for Insight articles.
// `author` follows the shape of MARK in lib/seoData.js.
export const AuthorBio = ({ author, datePublished, dateModified }) => {
  const initials = author.name
    .split(/\s+/)
    .filter(Boolean)
    .map((s) => s[0])
    .slice(0, 2)
    .join("");

  const fmt = (d) =>
    d
      ? new Date(d).toLocaleDateString("en-AU", { day: "numeric", month: "long", year: "numeric" })
      : null;

  return (
    <div
      className="flex items-start gap-4 rounded-2xl border border-zinc-800 bg-[#0a0a0a] p-5"
      data-testid="author-bio"
    >
      <div className="w-12 h-12 shrink-0 rounded-full bg-gradient-to-br from-[#E50914] to-[#A50710] flex items-center justify-center text-white font-bebas text-lg">
        {initials}
      </div>
      <div className="min-w-0">
        <Link
          to={author.path}
          className="text-white font-semibold hover:text-[#E50914] transition-colors"
          data-testid="author-bio-link"
        >
          {author.name}
        </Link>
        <p className="text-[#E50914] text-xs mb-1.5">{author.role}, {author.org}</p>
        <p className="text-zinc-400 text-sm leading-relaxed">{author.bioShort}</p>
        {(datePublished || dateModified) && (
          <p className="text-zinc-600 text-xs mt-2">
            {datePublished && <>Published {fmt(datePublished)}</>}
            {dateModified && dateModified !== datePublished && <> · Updated {fmt(dateModified)}</>}
          </p>
        )}
      </div>
    </div>
  );
};

export default AuthorBio;
